// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1r3Og","title":"BackImages_title__1V4Va","images":"BackImages_images__3Wstw"};